"use client"

/**
 * Mounts the Datadog Browser Logs + RUM SDKs once on the client. A no-op
 * without `NEXT_PUBLIC_DD_CLIENT_TOKEN`; RUM also needs
 * `NEXT_PUBLIC_DD_RUM_APPLICATION_ID`.
 */

import { useEffect } from "react"

import { initDatadog } from "@/lib/observability/datadog"

export function DatadogInit(): null {
  useEffect(() => {
    initDatadog()
  }, [])

  return null
}
